import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=2ddc97dd"
import script from "./TheLayout.vue?vue&type=script&lang=js"
export * from "./TheLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../tools/node_modules/.pnpm/vue-loader@15.11.1_oyhijetsnqchcaumwhvttdg63u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports